import type { Variants } from "framer-motion";

export type Variant = "logo-flip" | "wormhole" | "shutter" | "inkdrop";

export interface VariantConfig {
  exit: Variants;
  enter: Variants;
  occlusionAt: number;
  maxDurationMs: number;
}

// WARNING: Keep VARIANT_BY_ROUTE in sync with the lazy import paths in
// src/routes/index.tsx. Two-way drift here will break preload chunk sharing.
export const VARIANT_BY_ROUTE: Record<string, Variant> = {
  "/pricing": "logo-flip",
  "/coverage": "logo-flip",
  "/about": "logo-flip",
  "/docs": "logo-flip",
  "/verify": "wormhole",
  "/brokers/signup": "shutter",
  "/blog": "inkdrop",
};

export const VARIANTS: Record<Variant, VariantConfig> = {
  "logo-flip": {
    occlusionAt: 0.5,
    maxDurationMs: 1100,
    exit: {
      hidden: { opacity: 0 },
      visible: {
        opacity: 1,
        transition: { duration: 0.42, ease: [0.65, 0, 0.35, 1] },
      },
    },
    enter: {
      hidden: { opacity: 1 },
      visible: {
        opacity: 0,
        transition: { duration: 0.5, ease: [0.16, 1, 0.3, 1], delay: 0.05 },
      },
    },
  },

  wormhole: {
    occlusionAt: 0.55,
    maxDurationMs: 850,
    exit: {
      hidden: { opacity: 1, scale: 1, filter: "blur(0px)" },
      visible: {
        opacity: 0,
        scale: 2,
        filter: "blur(8px)",
        transition: { duration: 0.47, ease: "easeIn" },
      },
    },
    enter: {
      hidden: { opacity: 0, scale: 1.05, filter: "blur(8px)" },
      visible: {
        opacity: 1,
        scale: 1,
        filter: "blur(0px)",
        transition: { duration: 0.4, ease: "easeOut" },
      },
    },
  },

  shutter: {
    occlusionAt: 0.5,
    maxDurationMs: 750,
    exit: {
      hidden: { opacity: 1 },
      visible: {
        opacity: 0,
        transition: { duration: 0.375, ease: "easeInOut" },
      },
    },
    enter: {
      hidden: { opacity: 0 },
      visible: {
        opacity: 1,
        transition: { duration: 0.375, ease: "easeOut" },
      },
    },
  },

  inkdrop: {
    occlusionAt: 0.6,
    maxDurationMs: 900,
    exit: {
      hidden: { clipPath: "circle(0% at 50% 50%)", opacity: 1 },
      visible: {
        clipPath: "circle(150% at 50% 50%)",
        opacity: 1,
        transition: { duration: 0.54, ease: "easeIn" },
      },
    },
    enter: {
      hidden: { opacity: 0 },
      visible: {
        opacity: 1,
        transition: { duration: 0.36, ease: "easeOut" },
      },
    },
  },
};
